export const handleError = (error, context) => {
    console.error(`${context}エラー:`, error);
    
    // エラーメッセージの分類
    if (error.message.includes('FRAXの計測')) {
        return {
            message: error.message,
            type: 'frax'
        };
    }
    
    if (error.message.includes('ネットワーク')) {
        return {
            message: 'ネットワーク接続に問題が発生しました。受付にお声がけください。',
            type: 'network'
        };
    }
    
    if (error.message.includes('タイムアウト')) {
        return {
            message: '処理に時間がかかりすぎています。受付にお声がけください。',
            type: 'timeout'
        };
    }
    
    // デフォルトのエラーメッセージ
    return {
        message: 'エラーが発生しました。受付にお声がけください。',
        type: 'general'
    };
};

export const validateFraxResults = (results) => {
    if (!results || typeof results !== 'object') {
        throw new Error('FRAXの計測に問題があったようです。受付にお声がけください。');
    }

    if (!results.majorOsteoporotic || !results.hipFracture) {
        throw new Error('FRAXの計測に問題があったようです。受付にお声がけください。');
    }

    const majorOsteoporotic = parseFloat(results.majorOsteoporotic.replace('%', ''));
    const hipFracture = parseFloat(results.hipFracture.replace('%', ''));

    if (isNaN(majorOsteoporotic) || isNaN(hipFracture)) {
        throw new Error('FRAXの計測に問題があったようです。受付にお声がけください。');
    }

    return {
        majorOsteoporotic: results.majorOsteoporotic,
        hipFracture: results.hipFracture
    };
};

/**
 * FRAXの結果文字列をパースして数値に変換する共通関数
 * @param {string} fraxString - '%'を含むFRAX結果文字列
 * @param {number} defaultValue - パースに失敗した場合のデフォルト値
 * @returns {number} - パースした数値
 */
export const parseFraxValue = (fraxString, defaultValue = 0) => {
    if (!fraxString || typeof fraxString !== 'string') {
        return defaultValue;
    }

    try {
        const numericValue = parseFloat(fraxString.replace('%', ''));
        return isNaN(numericValue) ? defaultValue : numericValue;
    } catch (error) {
        console.error('FRAX値のパースエラー:', error, fraxString);
        return defaultValue;
    }
};

/**
 * 数値を安全にパースする共通関数
 * @param {any} value - パースする値
 * @param {number} defaultValue - パースに失敗した場合のデフォルト値
 * @returns {number} - パースした数値
 */
export const safeParseFloat = (value, defaultValue = 0) => {
    if (value === null || value === undefined || value === '') {
        return defaultValue;
    }

    try {
        const numericValue = parseFloat(value);
        return isNaN(numericValue) ? defaultValue : numericValue;
    } catch (error) {
        console.error('数値パースエラー:', error, value);
        return defaultValue;
    }
};

/**
 * 整数を安全にパースする共通関数
 * @param {any} value - パースする値
 * @param {number} defaultValue - パースに失敗した場合のデフォルト値
 * @returns {number} - パースした整数
 */
export const safeParseInt = (value, defaultValue = 0) => {
    if (value === null || value === undefined || value === '') {
        return defaultValue;
    }

    try {
        const numericValue = parseInt(value, 10);
        return isNaN(numericValue) ? defaultValue : numericValue;
    } catch (error) {
        console.error('整数パースエラー:', error, value);
        return defaultValue;
    }
}; 